import { useContext, useEffect, useRef, useState } from 'react'
import { useFormikContext } from 'formik'
import { StepperContext } from '~/components/ui/ViewStepper'
import { CloseButton } from '~/components'
import { useTranslation } from 'react-i18next'
import { useCustomEventListener, emitCustomEvent } from 'react-custom-events'
import { showModal } from '~/lib/modal'

const hideOnId = [''] // ID:s for views where this button should be hidden
const noModalOnId = ['done', 'inputPhone'] // ID:s for views where the confirm modal should be skipped

export default function ResetButton({ message }) {
  const { t } = useTranslation()
  const { id, reset: resetStepper } = useContext(StepperContext)
  const { values, initialValues, resetForm } = useFormikContext()
  const ref = useRef()
  const [isWaitingForPoll, setIsWaitingForPoll] = useState(false)

  // Check if in edit mode (bookingId exists and is valid)
  const isEditMode = !isNaN(values.bookingId) && values.bookingId > 0
  // Use edit message if in edit mode, otherwise use provided message or default booking message
  const confirmMessage = isEditMode ? t('reset-edit-message') : (message || t('reset-booking-message'))

  const reset = () => {
    if (isWaitingForPoll) {
      return // Don't allow reset when waiting for poll
    }
    const resetValues = initialValues;
    resetValues.isCompanyTrip = values.isCompanyTrip; // Preserve company trip status
    resetValues.company = values.company; // Preserve company name if set
    resetForm({
      values: resetValues
    })
    resetStepper()

    // Emit RESET_FORM and RESET_MAP events (same as Formik onReset handler)
    if (typeof APP !== 'undefined' && APP.trigger) {
      APP.trigger(APP.events.BOOKING_MODULE_SHOW_COVER)
    }
    emitCustomEvent('RESET_FORM')
    emitCustomEvent('RESET_MAP')
  }

  const [showReset, setShowReset] = useState(false);
  useCustomEventListener('RESET_FORM', () => {
    setShowReset(false);
  }, [setShowReset])

  useCustomEventListener('BOOKING_STARTED', () => {
    setShowReset(true);
  }, [setShowReset])

  // Listen for waiting for poll state
  useCustomEventListener('BOOKING_WAITING_FOR_POLL', ({ waiting }) => {
    setIsWaitingForPoll(waiting || false)
  }, [])

  const onClick = () => {
    if (isWaitingForPoll) {
      return // Don't allow reset when waiting for poll
    }
    if (noModalOnId.includes(id)) {
      reset()
    }
    else {
      showModal(confirmMessage, [
        { title: t('button-yes'), callback: reset },
        { title: t('button-no') },
      ])
    }
  }

  useEffect(() => {
    if (ref.current) {
      //const margin = ref.current?.parentElement?.querySelector('.notifications')?.offsetHeight || 0
      //ref.current.style.marginTop = `${margin}px`
    }
  }, [ref, id])

  // Do not show on some id:s
  if (!showReset) return null

  // booking-reset-button is a styling hook, not a behaviour flag: the embed hides
  // this button on desktop, where it would land on top of the bookings toggle.
  // Tagged here rather than on CloseButton so the modals' close buttons are unaffected.
  return (
    <CloseButton innerRef={ref} onClick={onClick} disabled={isWaitingForPoll} className="booking-reset-button" />
  )
}
